import React from 'react';
import { Box, TextField, Typography } from '@mui/material';
import { InvestorStatementEmailTemplateData } from '../../../models/admin/InvestorStatement';
import { Palette } from 'Palette';

const tone: keyof typeof Palette = 'default';

const standardTextFieldSx = {
  '& .MuiInput-underline:before': { borderBottom: 'none' },
  '& .MuiInput-underline:hover:before': { borderBottom: '1px solid rgba(0,0,0,0.42)' },
  '& .MuiInput-underline:after': { borderBottom: '1px solid rgba(0,0,0,0.42)' },
};

interface StatementEmailFieldRowProps {
  label: string;
  children: React.ReactNode;
}

const StatementEmailFieldRow: React.FC<StatementEmailFieldRowProps> = ({ label, children }) => (
  <Box sx={{ p: 2, borderBottom: `1px solid ${Palette[tone].border}` }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography
        sx={{ minWidth: '60px', fontSize: '0.875rem', color: Palette[tone].disabledText || '#666' }}
      >
        {label}
      </Typography>
      {children}
    </Box>
  </Box>
);

interface StatementEmailFieldsSectionProps {
  templateData: InvestorStatementEmailTemplateData;
  fromEmail: string;
  onFromEmailChange: (value: string) => void;
  subject: string;
  onSubjectChange: (value: string) => void;
}

/** From/To/Subject rows for StatementEmailComposePanel. */
const StatementEmailFieldsSection: React.FC<StatementEmailFieldsSectionProps> = ({
  templateData,
  fromEmail,
  onFromEmailChange,
  subject,
  onSubjectChange,
}) => (
  <>
    <StatementEmailFieldRow label="From:">
      <TextField
        value={fromEmail}
        onChange={(e) => onFromEmailChange(e.target.value)}
        placeholder="Enter sender email"
        variant="standard"
        fullWidth
        sx={standardTextFieldSx}
      />
    </StatementEmailFieldRow>

    <StatementEmailFieldRow label="To:">
      <Typography sx={{ flex: 1, fontSize: '0.875rem' }}>{templateData.contact.email}</Typography>
    </StatementEmailFieldRow>

    <StatementEmailFieldRow label="Subject:">
      <TextField
        value={subject}
        onChange={(e) => onSubjectChange(e.target.value)}
        variant="standard"
        fullWidth
        sx={standardTextFieldSx}
      />
    </StatementEmailFieldRow>
  </>
);

export default StatementEmailFieldsSection;
